import classnames from 'classnames';
import React, { InputHTMLAttributes } from 'react';

const CSS = require('./Input.module.scss');

type InputProp = {
  value?: string;
  onChange?: (e: any) => void;
  error?: boolean;
  className?: string;
} & InputHTMLAttributes<HTMLInputElement>;

function Input({ value, onChange, error, className, ...rest }: InputProp) {
  const classes = classnames(CSS.Input, {
    [CSS.Error]: error,
    [className]: !!className,
  });

  return (
    <input
      autoCorrect="off"
      className={classes}
      value={value}
      onChange={onChange}
      {...rest}
    />
  );
}

export default Input;
